module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_24-62db1449bc7f571de2e04315dd22d3e1.jpg";